import { render } from "./AllSales.vue?vue&type=template&id=751c1bd4&scoped=true"
import script from "./AllSales.vue?vue&type=script&lang=js"
export * from "./AllSales.vue?vue&type=script&lang=js"

import "./AllSales.vue?vue&type=style&index=0&id=751c1bd4&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751c1bd4"]])

export default __exports__